export var AccountReactivationIA = function AccountReactivationIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return ACCOUNT_REACTIVATION_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ACCOUNT_REACTIVATION_DESCRIPTION(strictLocalize)];
    }
  };
};
var ACCOUNT_REACTIVATION_TITLE = function ACCOUNT_REACTIVATION_TITLE(strictLocalize) {
  return strictLocalize({
    id: "pEaCXm",
    defaultMessage: [{
      "type": 0,
      "value": "Reativação da conta"
    }]
  });
};
var ACCOUNT_REACTIVATION_DESCRIPTION = function ACCOUNT_REACTIVATION_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "xhsL1w",
    defaultMessage: [{
      "type": 0,
      "value": "Se desativou a sua conta anteriormente, pode enviar um pedido de reativação utilizando a opção Contacte-nos abaixo. Observação: todas as solicitações relacionadas com a verificação de conta devem passar por A minha conta > Integração > Verificação de conta"
    }]
  });
};